export const backendBaseUrl = "https://album-listen-list-api.fly.dev";
// 'http://localhost:8080';
// "https://australia-southeast1-album-listen-list.cloudfunctions.net"
